import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import NavDropdown from "react-bootstrap/NavDropdown";
import Offcanvas from "react-bootstrap/Offcanvas";
import Dropdown from "react-bootstrap/Dropdown";

const Header = () => {
  const [scrolled, setScrolled] = useState(false);

  // Detect scroll position
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <>
      <Navbar
        expand="lg"
        fixed="top" // makes navbar fixed at top
        variant="dark"
        className={`custom-navbar ${scrolled ? "nav-scroll" : ""}`}
      >
        <Container>
          <Navbar.Brand href="/" className="fw-bold ">
            <img src="new4.png" width="100" alt="logo" />
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="offcanvasNavbar" />
          <Navbar.Offcanvas
            id="offcanvasNavbar"
            aria-labelledby="offcanvasNavbarLabel"
            placement="end"
            className="bg-danger text-white"
          >
            <Offcanvas.Header closeButton closeVariant="white">
              <Offcanvas.Title id="offcanvasNavbarLabel" className="text-white">
                Gayatry Infotech
              </Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body>
              <Nav className="justify-content-end flex-grow-1 pe-3">
                <Nav.Link href="/" className="nav-animate active">
                  Home
                </Nav.Link>
                < Nav.Link href="/Aboutpage" className="nav-animate">
                  About
                </Nav.Link>

                <NavDropdown
                  title={
                    <Link
                      to="/MainCoursePage"
                      className="text-decoration-none text-dark"
                    >
                      Courses
                    </Link>
                  }
                  id="courses-nav-dropdown"
                  className="nav-animate"
                  menuVariant="white"
                >

                  {/* Core Programming */}
                  <NavDropdown title="Web Designer" drop="end" menuVariant="white">
                    <NavDropdown.Item href="/CourseDetails">Courses Details</NavDropdown.Item>
                    <NavDropdown.Item href="/MainCoursePage">Main Courses Page</NavDropdown.Item>
                    <NavDropdown.Item href="/SubCoursePage">Sub Courses Page</NavDropdown.Item>
                  </NavDropdown>

                  {/* Web Development */}
                  <NavDropdown title="Web Development" drop="end" menuVariant="white">
                    <NavDropdown.Item href="/SubCoursePage">HTML5</NavDropdown.Item>
                    <NavDropdown.Item href="/SubCoursePage">CSS3</NavDropdown.Item>
                    <NavDropdown.Item href="/SubCoursePage">JavaScript</NavDropdown.Item>
                    <NavDropdown.Item href="/SubCoursePage">TypeScript</NavDropdown.Item>
                    <NavDropdown.Item href="/SubCoursePage">PHP</NavDropdown.Item>
                    <NavDropdown.Item href="/SubCoursePage">Ruby</NavDropdown.Item>
                  </NavDropdown>

                  {/* Mobile Development */}
                  <NavDropdown title="Mobile Development" drop="end" menuVariant="white">
                    <NavDropdown.Item href="#swift">Swift</NavDropdown.Item>
                    <NavDropdown.Item href="#kotlin">Kotlin</NavDropdown.Item>
                    <NavDropdown.Item href="#dart">Dart (Flutter)</NavDropdown.Item>
                    <NavDropdown.Item href="#android-java">Java (Android)</NavDropdown.Item>
                    <NavDropdown.Item href="#objectivec">Objective-C</NavDropdown.Item>
                  </NavDropdown>

                  {/* Data Science */}
                  <NavDropdown title="Data Science" drop="end" menuVariant="white">
                    <NavDropdown.Item href="#r">R</NavDropdown.Item>
                    <NavDropdown.Item href="#matlab">MATLAB</NavDropdown.Item>
                    <NavDropdown.Item href="#julia">Julia</NavDropdown.Item>
                    <NavDropdown.Item href="#python-ds">Python (Data Science)</NavDropdown.Item>
                  </NavDropdown>

                  {/* Database */}
                  <NavDropdown title="Database" drop="end" menuVariant="white">
                    <NavDropdown.Item href="#sql">SQL</NavDropdown.Item>
                    <NavDropdown.Item href="#mysql">MySQL</NavDropdown.Item>
                    <NavDropdown.Item href="#postgresql">PostgreSQL</NavDropdown.Item>
                    <NavDropdown.Item href="#mongodb">MongoDB</NavDropdown.Item>
                    <NavDropdown.Item href="#plsql">PL/SQL</NavDropdown.Item>
                  </NavDropdown>

                  {/* Functional & Logic */}
                  <NavDropdown title="Functional & Logic" drop="end" menuVariant="white">
                    <NavDropdown.Item href="#haskell">Haskell</NavDropdown.Item>
                    <NavDropdown.Item href="#elixir">Elixir</NavDropdown.Item>
                    <NavDropdown.Item href="#erlang">Erlang</NavDropdown.Item>
                    <NavDropdown.Item href="#scala">Scala</NavDropdown.Item>
                    <NavDropdown.Item href="#fsharp">F#</NavDropdown.Item>
                    <NavDropdown.Item href="#lisp">Lisp</NavDropdown.Item>
                    <NavDropdown.Item href="#prolog">Prolog</NavDropdown.Item>
                  </NavDropdown>

                  {/* Emerging */}
                  <NavDropdown title="Emerging" drop="end" menuVariant="white">
                    <NavDropdown.Item href="#go">Go (Golang)</NavDropdown.Item>
                    <NavDropdown.Item href="#rust">Rust</NavDropdown.Item>
                    <NavDropdown.Item href="#crystal">Crystal</NavDropdown.Item>
                    <NavDropdown.Item href="#nim">Nim</NavDropdown.Item>
                    <NavDropdown.Item href="#ocaml">OCaml</NavDropdown.Item>
                  </NavDropdown>

                  {/* Scripting & Automation */}
                  <NavDropdown title="Scripting & Automation" drop="end" menuVariant="white">
                    <NavDropdown.Item href="#bash">Bash / Shell</NavDropdown.Item>
                    <NavDropdown.Item href="#powershell">PowerShell</NavDropdown.Item>
                    <NavDropdown.Item href="#perl">Perl</NavDropdown.Item>
                    <NavDropdown.Item href="#groovy">Groovy</NavDropdown.Item>
                  </NavDropdown>
                </NavDropdown>

                <Nav.Link href="/BlogPage" className="nav-animate text-white">
                  Blog
                </Nav.Link>
                <Nav.Link href="/ContactPage" className="nav-animate text-white">
                  Contact Us
                </Nav.Link>
              </Nav>

              {/* Login Dropdown */}
              <Dropdown align="end" className="ms-lg-3 fw-bold  ">
                <Dropdown.Toggle

                  id="login-dropdown"
                  className="btn-grad border-0 fw-bold"
                  bsPrefix="btn"
                >
                  Login
                </Dropdown.Toggle>

                <Dropdown.Menu>
                  <Dropdown.Item href="#student-login">
                    Student Login
                  </Dropdown.Item>
                  <Dropdown.Item href="#admin-login">
                    Admin Login
                  </Dropdown.Item>
                  <Dropdown.Divider />
                  <Dropdown.Item href="#signup">Sign Up</Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </Offcanvas.Body>
          </Navbar.Offcanvas>
        </Container>
      </Navbar>
    </>
  );
};

export default Header;
